import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef, HTMLAttributes, PropsWithChildren } from 'react';
import { cn } from '@/Domain/utils/cn';

const boxIconVariants = cva('flex items-center justify-center rounded-lg transition-colors', {
  variants: {
    variant: {
      outlined: 'border border-border bg-transparent text-foreground shadow-sm',
      gray: 'border !border-transparent bg-muted text-muted-foreground',
    },
  },
  defaultVariants: {
    variant: 'outlined',
  },
});

export interface BoxIconProps
  extends PropsWithChildren, HTMLAttributes<HTMLDivElement>, VariantProps<typeof boxIconVariants> {}

export const BoxIcon = forwardRef<HTMLDivElement, BoxIconProps>(
  ({ variant = 'outlined', className, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(boxIconVariants({ variant }), 'h-[34px] w-[34px]', className)}
      {...props}
    >
      {children}
    </div>
  ),
);

BoxIcon.displayName = 'BoxIcon';
